import {IconDragHorizontal} from '@sdox/icons'

import {Button} from '../'

import type {ClassNameValue} from 'tailwind-merge'

const handleBarClasses: ClassNameValue = 'border-l-1 grow border-interactive-glyph-primary-inversed-default/40'

export const Handle = () => (
  <div className={'flex h-full flex-col items-center hover:cursor-pointer active:cursor-col-resize'}>
    <div className={handleBarClasses} />
    <div className={'inline-flex items-center justify-center'}>
      <Button
        className={'!flex active:cursor-col-resize @block-large:!hidden'}
        // if this variant changes again from "overlay-inversed" to "overlay" @toni.michel will buy pizza for the devs
        variant={'overlay-inversed'}
        leading={<IconDragHorizontal />}
        size={'small'}
      />
      <Button
        className={'!hidden active:cursor-col-resize @block-large:!flex'}
        // if this variant changes again from "overlay-inversed" to "overlay" @toni.michel will buy pizza for the devs
        variant={'overlay-inversed'}
        leading={<IconDragHorizontal />}
        size={'medium'}
      />
    </div>
    <div className={handleBarClasses} />
  </div>
)
